import React from "react";
import useLeaderboardProps from "hooks/useLeaderboardProps";
import { Grid, Typography, Skeleton, Tooltip } from "@mui/material";

const StatsCard = ({ title, value, tooltipText }) => {
  const { isLoading } = useLeaderboardProps();
  const statsValue = value || "N/A";
  const statsTitle = title || "Stat Title";

  const content = (
    <Grid
      container
      sx={{ bgcolor: "#202020", p: 1, mx: 1, borderRadius: 1 }}
      alignItems={"center"}
    >
      <Grid item xs={8}>
        <Typography variant="h2" textAlign={"start"} noWrap>
          {statsTitle.toUpperCase()}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="h4" textAlign={"end"}>
          {isLoading ? <Skeleton /> : statsValue}
        </Typography>
      </Grid>
    </Grid>
  );

  return tooltipText ? (
    <Tooltip title={tooltipText} arrow>
      {content}
    </Tooltip>
  ) : (
    content
  );
};

export default StatsCard;
